<script>
import DataProvider from './DataProvider.vue';
import SchoolYearRepository from '../../js/repository/SchoolYearRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: SchoolYearRepository.findAll,
                params: [this.kindergartenId],
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
